import React from 'react';
import PropTypes from 'prop-types';

const ProcessDescription = ({ resBurden }) => (
  <>
    <h2>Follow these steps to get started</h2>

    <va-process-list>
      <va-process-list-item header="Check your eligibility">
        <p>Check the eligibility requirements before you apply.</p>
        <p>
          <va-link
            text="Find out if you’re eligible for CHAMPVA benefits"
            href="/family-and-caregiver-benefits/health-and-disability/champva/"
          />
        </p>
        <p>
          We’ll also help you check your eligibility when you complete this
          form.
        </p>
        <p>
          <strong>Note:</strong> If you’re eligible for TRICARE, you can’t get
          CHAMPVA benefits. TRICARE is the Defense Department’s healthcare
          program for service members and their families.
        </p>
      </va-process-list-item>
      <va-process-list-item header="Gather your information">
        <p>You’ll need to provide personal information for these people:</p>
        <ul>
          <li>
            Yourself, <strong>and</strong>
          </li>
          <li>
            Anyone you’re applying for, <strong>and</strong>
          </li>
          <li>
            Your sponsor (the Veteran or service member you’re connected to)
          </li>
        </ul>
        <p>You may also need to submit these supporting documents:</p>
        <ul>
          <li>Health insurance cards</li>
          <li>Medicare cards or notice of disallowance if age 65 or older</li>
          <li>Proof of school enrollment</li>
          <li>Proof of marriage or legal union</li>
          <li>Proof of adoption</li>
          <li>Birth certificate of dependents</li>
        </ul>
        <p>
          <va-link
            text="Find out which documents you’ll need to apply for CHAMPVA"
            href="/family-and-caregiver-benefits/health-and-disability/champva/#supporting-documents-for-your-"
          />
        </p>
        <p>
          <strong>Note:</strong> In some cases, you may need to submit another
          form to coordinate benefits with your Medicare or other health
          insurance. This is the CHAMPVA Other Health Insurance Certification
          (VA Form 10-7959C). We’ll guide you to this form as you complete your
          CHAMPVA application.
        </p>
      </va-process-list-item>
      <va-process-list-item header="Start your application">
        <p>
          We’ll take you through each step of the process. It should take about{' '}
          {resBurden} minutes.
        </p>
      </va-process-list-item>
    </va-process-list>

    <div className="vads-u-margin-bottom--4">
      <va-details label="What happens after you apply">
        <p>We typically review applications within 5 business days.</p>
        <p>
          <strong>
            If we need more information or make a decision on your application
          </strong>
          , we’ll mail you a letter.
        </p>
      </va-details>
    </div>
  </>
);

ProcessDescription.propTypes = {
  resBurden: PropTypes.number,
};

export default ProcessDescription;
